import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatPaginator, MatSort } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';
import { SweetAlertService } from '../../../../services/sweet-alert/sweet-alert.service';
import { fuseAnimations } from '../../../../../core/animations';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { TranslationService } from '../../../../services/translation/translation.service';
import { IStudent } from '../../../../models/students/i-student';
import { Student } from '../../../../models/students/student';
import { DivisionService } from '../../../../services/divisions/division.service';
import { Tutor } from '../../../../models/tutors/tutor';
import { Division } from '../../../../models/divisions/division';
import { ReportService } from '../../../../services/reports/report.service';
import { ActivatedRoute } from '@angular/router';
import { SubjectDataSource } from './subjectDataSource';
import { SubjectDatabase } from './subjectDatabase';
import { SubjectService } from '../../../../services/subject/subject.service';
import { Subject } from '../../../../models/subjects/subject';
import { AddSubjectComponent } from './components/add-subejct/add-subject.component';

@Component({
    selector: 'fuse-management-subjects',
    templateUrl: './subject.component.html',
    styleUrls: ['./subject.component.scss'],
    animations: fuseAnimations
})
export class SubjectComponent implements OnInit, OnDestroy {
    @BlockUI('tracker') blockUI: NgBlockUI;
    displayedColumns = ['Name', 'Description', 'Actions'];
    subjectDatabase;
    dataSource: SubjectDataSource | null;
    confirmDialogRef: any;

    private sub: any;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('filter') filter: ElementRef;
    public divisionSelected = -1;

    constructor(
        private activatedRoute: ActivatedRoute,
        private authenticationService: AuthenticationService,
        public dialog: MatDialog,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private subjectService: SubjectService,
        private divisionService: DivisionService,
        private reportService: ReportService,
        private route: ActivatedRoute
    ) {
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);

        this.sub = this.route.params.subscribe(params => {
            if (params['id'] !== undefined) {
                this.divisionSelected = +params['id']; // (+) converts string 'id' to a number
            }
        });

        this.subjectDatabase = new SubjectDatabase(this.subjectService);
        this.dataSource = new SubjectDataSource(this.subjectDatabase, this.paginator, this.sort);
        Observable.fromEvent(this.filter.nativeElement, 'keyup')
            .debounceTime(150)
            .distinctUntilChanged()
            .subscribe(() => {
                if (!this.dataSource) {
                    return;
                }
                this.dataSource.filter = this.filter.nativeElement.value;
            });
        this.blockUI.stop();
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    add() {
        const subject = new Subject();

        const config: MatDialogConfig = {
            // height: '75%',
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                mode: 'new',
                subject: Object.assign({}, subject)
            }
        };

        this.confirmDialogRef = this.dialog.open(AddSubjectComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            if (result !== true) {
                this.subjectDatabase.add(result);
            }
        });
    }

    editOrView(mode: string, subject: Subject) {
        console.log('subject>>>', subject);
        const config: MatDialogConfig = {
            // height: '75%',
            width: '50%',
            disableClose: true,
            panelClass: 'ea-dialog',
            data: {
                mode: mode,
                subject: Object.assign({}, subject)
            }
        };

        this.confirmDialogRef = this.dialog.open(AddSubjectComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            if (result !== true) {
                if (mode === 'edit') {
                    this.subjectDatabase.edit(result);
                }
            }
        });
    }

    // delete(student: IStudent) {
    //     this.translationService.translate('LABELS.DELETION_CONFIRMATION_QUESTION', student.LastName + ' ' + student.FirstName, (res) => {
    //         this.sweetAlertService.question(this.translationService.confirmation, res, this.translationService.yes, this.translationService.no, () => {
    //             this.subjectService.delete(student.Id).subscribe(response => {
    //                 if (response.resultCode === 1) {
    //                     this.subjectDatabase.delete(student);
    //                     const index = this.studentService.students.findIndex(s => s.Id === student.Id);
    //                     if (index >= 0) {
    //                         this.studentService.students.splice(index, 1);
    //                         delete this.studentService.studentObject[student.Id];
    //                     }
    //                     this.sweetAlertService.success(this.translationService.success, this.translationService.deletedCorrectly, null);
    //                 } else {
    //                     this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (r: string) => {
    //                         this.sweetAlertService.error('Error', r, null);
    //                     });
    //                 }
    //             }, error => {
    //                 this.translationService.translate('ERRORS.ERROR_REQUEST', error, (r: string) => {
    //                     this.sweetAlertService.error('Error', r, null);
    //                 });
    //             });
    //         }, () => {
    //             console.log('FuseStudentComponent > delete > canceled');
    //         });
    //     });
    // }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/subjects/subject.component.ts